/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React from 'react';
import { WithWizard } from 'react-albus';
import { Button } from 'reactstrap';
import { IStep } from '../../globals/interfaces';

const BottomNavigation = ({
	className,
	onClickPrev,
	onClickNext,
	prevLabel,
	nextLabel,
	resolveEnableNext,
	resolveEnablePrev,
	hideOnStepId
}: {
	className: string;
	onClickPrev: (goToPrev: () => void, steps: Array<IStep>, step: IStep, push?) => void;
	onClickNext: (goToNext: () => void, steps: Array<IStep>, step: IStep, push?) => void;
	prevLabel?: string;
	nextLabel?: string;
	resolveEnableNext?: (step: IStep) => boolean;
	resolveEnablePrev?: (step: IStep) => boolean;
	hideOnStepId?: string;
}) => {

	return (
		<WithWizard
			render={({ next, previous, step, steps, push }) => hideOnStepId !== step.id && (
				<div className={`wizard-buttons ${className} pt-3`}>
					<Button
						color="primary"
						className={`mr-1 ${steps.indexOf(step) <= 0  || (resolveEnablePrev && !resolveEnablePrev(step)) ? 'disabled' : ''}`}
						onClick={() => {
							onClickPrev(previous, steps, step, push);
						}}
					>
						{prevLabel}
					</Button>

					<Button
						color="primary"
						className={
							steps.indexOf(step) >= steps.length - 1 || (resolveEnableNext && !resolveEnableNext(step)) ? 'disabled' : ''
						}
						onClick={() => {
							resolveEnableNext(step) && onClickNext(next, steps, step, push);
						}}
					>
						{nextLabel}
					</Button>
				</div>
			)}
		/>
	);
};
export default BottomNavigation;
